import React, { Component } from "react";
import PageNotFound from "./components/__pages/PageNotFound";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: "",
      errorInfo: "",
      hasError: false,
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  // componentDidCatch(error, errorInfo) {
  //   console.log({ error, errorInfo });
  //   console.log("CAUGHT");
  //   this.setState({ errorInfo });
  // }

  render() {
    const { hasError, errorInfo } = this.state;

    if (hasError) {
      console.log(errorInfo);
      return <PageNotFound errorCode={500} />;
    }

    return this.props.children;
  }
}
